import React from 'react';
import logoImage from '../assets/logo.png';

const Logo = ({ size = 'medium', variant = 'dark' }) => {
  const sizes = {
    small: { height: '30px' },
    medium: { height: '40px' },
    large: { height: '50px' }
  };
  
  const { height } = sizes[size] || sizes.medium;

  return (
    <div className="tapmyback-logo" style={{ display: 'flex', alignItems: 'center' }}>
      <img 
        src={logoImage} 
        alt="TapMyBack" 
        style={{ 
          height: height,
          width: 'auto',
          display: 'block',
          // If variant is light (on green background), apply brightness filter to make it white
          filter: variant === 'light' ? 'brightness(0) invert(1)' : 'none'
        }} 
      />
    </div>
  );
};

export default Logo;
